import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import React, { useEffect } from 'react';
import { TailSpin } from 'react-loader-spinner';
import { useUserContext } from '../../contexts/UserContext';

import StaffNavBarTemplate from '../../features/NavBar/templates/StaffNavBarTemplate';
import Login from '../../features/Login/pages/Login';

import logo from '../../assets/images/logo-white.png';
import MapOnDemandClient from '../../features/MapOnDemandClient/pages/MapOnDemandClient';
import CreateBundle from '../../features/CreateBundle/pages/CreateBundle';
import { useClientContext } from '../../contexts/ClientContext';

const StaffPortal = () => {
  const appUser = useUserContext();
  const client = useClientContext();

  useEffect(() => {
    appUser.checkUser();
    appUser.checkToken();
  });

  return (
    <div>

      <AuthenticatedTemplate>
        {!appUser.token
              && (
              <div style={{
                display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',
              }}
              >
                <TailSpin className="mx-auto" color="#00BFFF" height={200} width={200} visible={!appUser.token} />
              </div>
              )}
        {appUser.token && (
          <div>
            <StaffNavBarTemplate pageLogo={logo} pageName="MAP On Demand" />
            <MapOnDemandClient />
            <CreateBundle
              clientId={client.clientId}
              client={client.client}
              setClient={client.setClient}
            />
          </div>
        )}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default StaffPortal;
